export default __webpack_public_path__ + "static/transport-truck-7e3a87cde990696c8709cb393e93a222.jpg";